import React, { useEffect, useState } from "react";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import circleImage from "../assets/images/circleIcon.png";
import ApiLoader from "../components/ApiLoader";
import API_BASE_URL from "../utilities/ApiConfig";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const BankFileModal = ({ onClose }) => {
  const [loading, setLoading] = useState(false);
  const [deedTypeList, setDeedTypeList] = useState([]);
  const [subDeedTypeList, setSubDeedTypeList] = useState([]);
  const [deed, setDeed] = useState("");
  const [subdeed, setSubdeed] = useState("");
  const navigate = useNavigate();

  const handleGetDeedType = async () => {
    try {
      debugger;
      setLoading(true);
      const response = await axios.get(
        `${API_BASE_URL}/Registration/getDeedNames?mode=BANKFILE`
      );
      console.log("Deed Names Data:", response.data);
      if (response.status === 200) {
        setDeedTypeList(response?.data);
      } else {
        toast.error(response?.data?.statusResponse?.status);
      }
    } catch (error) {
      toast.error(
        "Failed to fetch Deed Type Data Due to Unexpected error Please Try Again"
      );
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleGetSubDeedType = async () => {
    if (deed) {
      try {
        debugger;
        setLoading(true);
        const response = await axios.get(
          `${API_BASE_URL}/Registration/getSubDeedNames?mode=${deed}`
        );
        console.log("SubDeed Names Data:", response.data);
        if (response.status === 200) {
          setSubDeedTypeList(response?.data);
          console.log("SUBDEED:", response?.data);
        } else {
          toast.error(response?.data?.statusResponse?.status);
        }
      } catch (error) {
        toast.error(
          "Failed to fetch Deed Type Data Due to Unexpected error Please Try Again"
        );
        console.log(error);
      } finally {
        setLoading(false);
      }
    }
  };
  useEffect(() => {
    handleGetDeedType();
    if (deed) {
      handleGetSubDeedType();
    }
  }, [deed]);
  const handleDeedChange = (event) => {
    setDeed(event.target.value);
  };
  const handleSubDeedChange = (event) => {
    setSubdeed(event.target.value);
  };

  const handleOK = () => {
    if (!deed || !subdeed) {
      toast.error("Please select both Deed and Subdeed.");
      return;
    }

    // Construct the query string with additional parameters
    const queryParams = new URLSearchParams({
      deed: deed,
      subdeed: subdeed,
    }).toString();
    debugger;
    // Navigate to BankPage with updated query parameters
    navigate(`/BankFileLand?${queryParams}`);

    onClose();
  };

  return (
    <>
      {loading && <ApiLoader />}
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-primary-black bg-opacity-50">
        <div className="bg-white w-full max-w-2xl relative">
          {/* Custom Header */}
          <div className="relative bg-[#CAE5FF] px-4 py-2 flex items-center justify-between border-b-4 border-[#3A8FF6] w-full">
            <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-white rounded-full p-2 shadow-md">
              <img src={circleImage} alt="Circle Icon" className="h-12 w-12" />
            </div>
            <h2 className="text-lg font-semibold ml-4">Choose Deed/Subdeed</h2>
            <button
              onClick={onClose}
              className="text-secondary-600 hover:text-secondary-900"
            >
              <CloseOutlinedIcon />
            </button>
          </div>
          <div className="m-4">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              <div className="col-span-1">
                <div className="relative">
                  <select
                    className="w-full h-8 border border-secondary-300  rounded focus:outline-none focus:ring-2 focus:ring-primary-500 peer text-sm text-primary-black"
                    value={deed}
                    onChange={handleDeedChange} // Set selected deed
                  >
                    <option value="">Select Deed</option>
                    {deedTypeList.map((deedItem, index) => (
                      <option key={index} value={deedItem}>
                        {deedItem}
                      </option>
                    ))}
                  </select>
                  <label
                    htmlFor="Deed"
                    className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                  >
                    Deed
                  </label>
                </div>
              </div>

              <div className="col-span-1">
                <div className="relative">
                  <select
                    className="w-full h-8 border border-secondary-300  rounded focus:outline-none focus:ring-2 focus:ring-primary-500 peer text-sm text-primary-black"
                    value={subdeed}
                    onChange={handleSubDeedChange} // Set selected deed
                  >
                    <option value="">Select Deed</option>
                    {subDeedTypeList.map((subDeedItem, index) => (
                      <option key={index} value={subDeedItem}>
                        {subDeedItem}
                      </option>
                    ))}
                  </select>
                  <label
                    htmlFor="SubDeed"
                    className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                  >
                    SubDeed
                  </label>
                </div>
              </div>
            </div>
            {/* Button */}
            <div className="flex justify-center mt-6">
              <button
                onClick={handleOK}
                className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-full text-sm font-medium"
              >
                Okay
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BankFileModal;
